let rebuyButtonListenerBound = false;
let templateCartButtonListenerBound = false;
let rebuyButtonClickHandler;
let templateCartButtonClickHandler;

function checkCartForAddress() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let addressDetected = false;

      // Detect if any item has an Address property
      for (const item of cart.items) {
        if (item.properties && item.properties.Address && item.properties.Address.trim() !== '') {
          addressDetected = true;
          break;
        }
      }

      // Handle the .rebuy-cart__checkout-button
      const rebuyCheckoutButton = document.querySelector('.rebuy-cart__checkout-button');
      if (rebuyCheckoutButton) {
        if (addressDetected && !rebuyButtonListenerBound) {
          // Address found: add redirect to /a/gs/cart/
          rebuyButtonClickHandler = (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            window.location.href = '/a/gs/cart/';
          };
          rebuyCheckoutButton.addEventListener('click', rebuyButtonClickHandler, true);
          rebuyButtonListenerBound = true;
        } else if (!addressDetected && rebuyButtonListenerBound) {
          // No address found: remove previously added listener to restore default behavior
          rebuyCheckoutButton.removeEventListener('click', rebuyButtonClickHandler, true);
          rebuyButtonListenerBound = false;
        }
      }

      // Handle the .template-cart .checkout_button
      const templateCartCheckoutButton = document.querySelector('.template-cart .checkout_button');
      if (templateCartCheckoutButton) {
        if (addressDetected && !templateCartButtonListenerBound) {
          // Address found: add redirect to /a/gs/cart/
          templateCartButtonClickHandler = (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            window.location.href = '/a/gs/cart/';
          };
          templateCartCheckoutButton.addEventListener('click', templateCartButtonClickHandler, true);
          templateCartButtonListenerBound = true;
        } else if (!addressDetected && templateCartButtonListenerBound) {
          // No address found: remove previously added listener to restore default behavior
          templateCartCheckoutButton.removeEventListener('click', templateCartButtonClickHandler, true);
          templateCartButtonListenerBound = false;
        }
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

  
  document.addEventListener('DOMContentLoaded', () => {
    checkCartForAddress();
    
      document.addEventListener('rebuy:cart.change', (event) => { 
        setTimeout(checkCartForAddress, 100);
      });
  });